export default {
  name: 'SelectEmployeeCustControl',
  components: {

  },
  props: {
    displayString: {
      type: String,
      required: true
    },
    employees: {
      type: Array,
      required: true
    },
    defaultEmployeeIdSelected: {
      type: Number,
      default: null
    },
    defaultElementHeight: { //default height for dropdown element
      type: String,
      default: '58'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      orgPostSelected: {},
      employeeSelected: [],
      orgPosts: [],
      defaultOrgPostIdSelected: -1,
    }
  },
  computed: {
    employeesTrimed: function () {
      this.employeeSelected = null;
      this.employeeSelectedFunc(null);

      if (this.orgPostSelected && this.orgPostSelected.id) {
        return this.employees.filter(e => e.orgPost == this.orgPostSelected.id);
      }
      else
        return this.employees;
    },
    defaultElemHeight: function () {
      if (this.defaultElementHeight != null)
        return `height: ${this.defaultElementHeight}px!important;`;
      else
        return '';
    }
  },
  watch: {
    employeeSelected: function (val) {
      this.employeeSelectedFunc(val)
    }
  },
  created() {
    this.orgPosts = this.$store.getters.getOrgPosts;
  },
  mounted() {
    this.setDefaultEmployee(this.defaultEmployeeIdSelected);
  },
  methods: {
    employeeSelectedFunc(val) {
      this.$emit('selected', val != null ? val.employeeId : null);
    },
    setDefaultEmployee(val) {
      let selectedEmployee = this.employees.filter(e => e.employeeId == val);
      if (selectedEmployee)
        this.employeeSelected = selectedEmployee[0];
      else
        this.employeeSelected = null;

      //let selectedEmployee = this.employees.filter(e => e.employeeId == val)[0];

      //if (selectedEmployee != null) {
      //  let item = selectedEmployee[this.searchString];

      //  if (item != null && item != '') {
      //    let temp = this.employees.filter(e => e[this.searchString] == item);
      //    if (temp != null && temp.length > 0) {
      //      this.employeeSelected = temp[0];
      //      return;
      //    }
      //  }
      //}

      //this.employeeSelected = {};
    },
  }
}

